import type { ResolvedFilters } from "@/services/mergeTags";

/**
 * Formats a merge-tag chip's visible label, appending an if/else fallback as
 * `Label / fallback` verbatim. Shared so the editor chip and read-only surfaces
 * render identical text.
 */
export function formatMergeTagChipLabel(
  label: string,
  filters?: ResolvedFilters,
): string {
  const fallback =
    typeof filters?.default === "string" && filters.default.length > 0
      ? filters.default
      : undefined;
  if (!fallback) return label;
  return `${label} / ${fallback}`;
}
